module.exports = {
  pa: {
    name: "Codere APPuestas PA",
    name_id: "codere-panama-app-2",
    description: "Codere Apuestas Online",
    email: "info@codere.pa",
    url: "https://www.codere.pa",
    id: "pa.codere.apuestas",
    hostname: "codere.pa",
    facebookAppId: "815661290325684",
    appLinkAndroid: "https://play.google.com/store/apps/details?id=pa.codere.apuestas",
    appLinkiOS: "https://apps.apple.com/us/app/codere-apuestas-deportivas-pa/id1498747318",
    prod: {
      chcp: "https://m.codere.pa/deportesPanama/",
      package: "pa.codere.apuestas",
    },
    qa: {
      chcp: "https://dm.apuestas.codere.es/DeportesQAPa/",
      package: "pa.codere.apuestas_uat",
    },
    dev: {
      chcp: "https://dm.apuestas.codere.es/DeportesDevPa/",
      package: "pa.codere.apuestas_uat",
    },
    mirror: {
      chcp: "https://m.codere.pa/DeportesMirrorPa/",
      package: "pa.codere.apuestas",
    },
    mirror2: {
      chcp: "https://m.codere.pa/DeportesMirror2Pa/",
      package: "pa.codere.apuestas",
    },
  },
  mx: {
    name: "Codere APPuestas MX",
    name_id: "codere-mexico-app",
    description: "Codere Apuestas Online",
    url: "https://m.codere.mx",
    id: "mx.codere.apuestas",
    email: "info@codere.mx",
    hostname: "codere.mx",
    prod: {
      chcp: "https://m.codere.mx/deportes/",
      package: "mx.codere.apuestas",
    },
    qa: {
      chcp: "https://q.mx.bet.cdrsbg.com/webappv2/",
      package: "mx.codere.apuestas_uat",
    },
    mirror: {
      chcp: "https://m.codere.mx/deportes/",
      package: "mx.codere.apuestas",
    },
    mirror2: {
      chcp: "https://m.codere.mx/deportes/",
      package: "mx.codere.apuestas",
    },
    dev: {
      chcp: "https://q.mx.bet.cdrsbg.com/webappv2/",
      package: "mx.codere.apuestas_uat",
    },
  },
  co: {
    name: "Codere APPuestas CO",
    name_id: "codere-colombia-app",
    description: "Codere Apuestas Online",
    url: "https://www.codere.com.co",
    id: "co.codere.apuestas",
    email: "info@codere.com.co",
    hostname: "codere.com.co",
    facebookAppId: "326307168879275",
    appLinkAndroid: "https://play.google.com/store/apps/details?id=co.codere.apuestas",
    appLinkiOS: "https://apps.apple.com/us/app/codere-apuestas-deportivas-co/id1313823849",
    prod: {
      chcp: "https://m.codere.com.co/deportesCol/",
      package: "co.codere.apuestas",
    },
    qa: {
      chcp: "https://q.mx.bet.cdrsbg.com/DeportesQACo/",
      package: "co.codere.apuestas",
    },
    dev: {
      chcp: "https://q.mx.bet.cdrsbg.com/DeportesDevCo/",
      package: "co.codere.apuestas",
    },
    mirror: {
      chcp: "https://m.codere.com.co/DeportesMirrorCo/",
      package: "co.codere.apuestas",
    },
    mirror2: {
      chcp: "https://m.codere.com.co/DeportesMirror2Co/",
      package: "co.codere.apuestas",
    },
  },
  co_casino: {
    name: "Codere Casino",
    name_id: "codere-colombia-casino",
    description: "Codere Casino Online",
    url: "https://www.codere.com.co",
    id: "co.codere.casino",
    email: "info@codere.com.co",
    hostname: "codere.com.co",
    facebookAppId: "723139269707383",
    prod: {
      chcp: "https://m.codere.com.co/deportesCol/",
      package: "co.codere.apuestas",
    },
    qa: {
      chcp: "https://q.mx.bet.cdrsbg.com/DeportesQACo/",
      package: "co.codere.apuestas",
    },
    dev: {
      chcp: "https://q.mx.bet.cdrsbg.com/DeportesDevCo/",
      package: "co.codere.apuestas",
    },
    mirror: {
      chcp: "https://m.codere.com.co/DeportesMirrorCo/",
      package: "co.codere.apuestas",
    },
    mirror2: {
      chcp: "https://m.codere.com.co/DeportesMirror2Co/",
      package: "co.codere.apuestas",
    },
  },
  es_casino: {
    name: "Codere Casino",
    name_id: "codere-spain-casino",
    description: "Codere Casino Online",
    url: "https://m.apuestas.codere.es",
    id: "spain.codere.casino",
    email: "info@codere.es",
    hostname: "codere.es",
    facebookAppId: "1543168422780865",
    prod: {
      chcp: "https://m.apuestas.codere.es/deportesEs/",
      // chcp:"/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
    qa: {
      // chcp:"https://dm.apuestas.codere.es/webappv2//",
      chcp: "https://dm.apuestas.codere.es/DeportesQAEs/",
      // package : 'es.codere.apuestas_uat',
      package: "spain.codere.apuestas",
    },
    mirror: {
      chcp: "https://m.apuestas.codere.es/DeportesMirrorEs/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
    mirror2: {
      chcp: "https://m.apuestas.codere.es/DeportesMirror2Es/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
    dev: {
      chcp: "https://dm.apuestas.codere.es/DeportesDevEs/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
  },
  es: {
    name: "Codere APPuestas ES",
    name_id: "codere-spain-app",
    description: "Codere Apuestas Online",
    url: "https://m.apuestas.codere.es",
    id: "spain.codere.apuestas", //ios shuld be es.codere.
    email: "info@codere.es",
    hostname: "codere.es",
    facebookAppId: "2919242785023022",
    appLinkAndroid: "https://play.google.com/store/apps/details?id=spain.codere.apuestas",
    appLinkiOS: "https://apps.apple.com/us/app/codere-apuestas-deportivas-es/id917178660",
    prod: {
      chcp: "https://m.apuestas.codere.es/deportesEs/",
      // chcp:"/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
    qa: {
      // chcp:"https://dm.apuestas.codere.es/webappv2//",
      chcp: "https://dm.apuestas.codere.es/DeportesQAEs/",
      // package : 'es.codere.apuestas_uat',
      package: "spain.codere.apuestas",
    },
    mirror: {
      chcp: "https://m.apuestas.codere.es/DeportesMirrorEs/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
    mirror2: {
      chcp: "https://m.apuestas.codere.es/DeportesMirror2Es/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
    dev: {
      chcp: "https://dm.apuestas.codere.es/DeportesDevEs/",
      package: "spain.codere.apuestas", //ios shuld es.codere
    },
  },
  ar: {
    name: "Codere APPuestas AR",
    name_id: "codere-argentina-app",
    description: "Codere Apuestas Online",
    url: "https://qm.codere.com.ar", //falta domino prod
    id: "ar.codere.apuestas",
    email: "info@codere.es",
    hostname: "codere.com.ar",
    appLinkiOS: "https://apps.apple.com/us/app/codere-apuestas-deportivas-ar/id6746136134",
    prod: {
      chcp: "https://m.caba.codere.bet.ar/Deportes/", //falta pr/od
      package: "ar.codere.apuestas",
    },
    mirror: {
      chcp: "https://m.caba.codere.bet.ar/DeportesMirrorCABA/",
      package: "ar.codere.apuestas", //uat
    },
    mirror2: {
      chcp: "https://m.caba.codere.bet.ar/DeportesMirror2CABA/",
      package: "ar.codere.apuestas", //uat
    },
    dev: {
      chcp: "https://qm.codere.com.ar/deportes/",
      package: "ar.codere.apuestas", //uat
    },
    qa: {
      chcp: "https://qm.codere.com.ar/DeportesQACABA/",
      package: "ar.codere.apuestas", //uat
    },
  },
  mendoza: {
    name: "Codere APPuestas Mendoza",
    name_id: "codere-mendoza-app",
    description: "Codere Apuestas Online",
    url: "https://m.mdz.codere.bet.ar/deportesMendoza/#/HomePage", //falta dominio qa
    id: "mdz.codere.apuestas",
    email: "info@codere.es",
    hostname: "codere.com.mdz",
    prod: {
      chcp: "https://m.mdz.codere.bet.ar/deportesMendoza/",
      package: "ar.codere.apuestas",
    },
    mirror: {
      chcp: "https://m.mdz.codere.bet.ar/deportesMendoza/",
      package: "ar.codere.apuestas",
    },
    mirror2: {
      chcp: "https://m.mdz.codere.bet.ar/deportesMendoza/",
      package: "ar.codere.apuestas",
    },
    dev: {
      chcp: "https://m.mdz.codere.bet.ar/deportesMendoza/",
      package: "ar.codere.apuestas",
    },
    qa: {
      chcp: "https://m.mdz.codere.bet.ar/deportesMendoza", //falta dominio /qa
      package: "ar.codere.apuestas", //uat
    },
  },
};
